module.exports = __webpack_public_path__ + "static/condo_design-4-feed06da4dbae97de28cc4d9b976d046.jpg";